import React from "react";
import styled from "styled-components";

import Spinner from "./utils/Spinner";

const Styled = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  gap: 1rem;
  color: #999;
  padding: 0.5rem 1rem;

  // we want NoResults to be the same height as Loading
  min-height: 6.4rem;

  svg {
    fill: #777;
    width: 2.4rem;
  }
`;

/** This will play a fancy animation as the application loads. */
const Loading: React.FC<React.PropsWithChildren<unknown>> = (props) => {
  return (
    <Styled>
      <Spinner />
      <div>{props.children}</div>
    </Styled>
  );
};

export default Loading;
